import { jsxs, jsx } from "react/jsx-runtime";
import { Box, TextButton, IconChevronDownOutline } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import { useState } from "react";
import ThemeCmsConstellation from "../../themes/ThemeCmsConstellation.esm.js";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BUserNav.utils.esm.js";
import SignOut from "./SignOut.esm.js";
const SignIn = ({
  user,
  // signInLink can be realtive (starts with "/") or it can omit this starting
  // "/"
  signInLink,
  redirectParam,
  env,
  router,
  inverse,
  userMenuItems
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const domain = env === "prod" || env === "production" ? "https://www.zillow.com" : "https://www.qa.zillow.net";
  const [dropdown, setDropdown] = useState(false);
  const signOutURL = domain + "/Logout.htm";
  const redirectUrl = domain + router.asPath;
  let signInURL;
  const isSignInLinkWithDomain = signInLink.startsWith("https");
  if (isSignInLinkWithDomain) {
    signInURL = new URL(signInLink);
  } else {
    signInURL = new URL(domain);
    signInURL.pathname = signInLink;
  }
  signInURL.searchParams.append(redirectParam, redirectUrl);
  const onMouseEnter = () => {
    setDropdown(true);
  };
  const onMouseLeave = () => {
    setDropdown(false);
  };
  if (user) {
    return /* @__PURE__ */ jsxs(Box, { as: TextButton, inverse, fontType: "bodySmall", buttonType: "secondary", "aria-label": "Account Menu", onMouseEnter, onMouseLeave, onClick: yieldCallback(() => {
      setDropdown(!dropdown);
    }), icon: /* @__PURE__ */ jsx(IconChevronDownOutline, {}), iconPosition: "end", iconSize: "xs", sx: {
      position: "relative",
      color: inverse ? "$colors.textWhite" : dropdown ? "$colors.blue400" : void 0
    }, children: [
      dropdown && /* @__PURE__ */ jsx(Box, { sx: {
        top: 0,
        left: `-${ThemeCmsConstellation.constellation.spacing.md}px`,
        right: `-${ThemeCmsConstellation.constellation.spacing.sm}px`,
        bottom: `-${ThemeCmsConstellation.constellation.spacing.xxl * 1.5}px`,
        position: "absolute",
        zIndex: `$zIndices.popover`
      } }),
      /* @__PURE__ */ jsx(Box, { as: "span", sx: {
        textDecoration: "none",
        color: "inherit",
        "@media $sm_lte": {
          display: "none"
        }
      }, children: [user.firstName, user.lastName].filter(Boolean).join(" ") || "My Account" }),
      /* @__PURE__ */ jsx(Box, { as: "span", sx: {
        display: "none",
        textDecoration: "none",
        color: "inherit",
        "@media $sm_lte": {
          display: "block"
        }
      }, children: "My Account" }),
      /* @__PURE__ */ jsx(SignOut, { url: signOutURL, dropdown, userMenuItems })
    ] });
  } else if (user === false) {
    return /* @__PURE__ */ jsx(TextButton, { buttonType: "secondary", inverse, as: "a", href: signInURL.href, fontType: "bodySmall", onClick: yieldCallback(() => {
      sendEvent("cms_anchor", "Sign In", signInURL.href, cmsInfo);
    }), children: "Sign In" });
  } else {
    return null;
  }
};
export {
  SignIn as default
};
